import React from 'react';
import { useService } from '../../../Data/Services';
import { useParams } from 'react-router-dom';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import Form, { Actions, Assets, Duration, RequiredValidator, Switch, TextArea, TextField } from '../../../Components/Form';
import { useDialogues } from '../../../Components/Dialogues';

const Edit = () => {
    const {serviceId} = useParams();
    const {service, update, deleteService} = useService(serviceId);
    const {confirm} = useDialogues();

    return <>
        <TopBar left="BackBtn"
            title={service ? service.title : 'Edit service'}
        />

        <Page>
            <Form data={service} waitForData onSubmit={update} goBackOnSubmit>
                <TextField name="title" label="Title" validators={[RequiredValidator]} />
                <TextArea name="description" label="Description" />
                <Duration name="defaultDuration"
                    label="Duration"
                    help="When scheduling jobs in the calendar, if a job does not have a specific duration set, this default duration is used."
                />
                <Switch name="showOnWebsite" label="Show on website" />
                <Switch name="showOnQuotes" label="Show on quote form" />
                <Assets name="assets"
                    label="Images"
                    help="These images will be shown on your getSoapy website"
                    tags={[{name: 'Service', value: service?.type}]}
                    dimensions={['300x']}
                    showPrevious
                    showShared
                />
                <Actions
                    submit={{label: 'Save'}}
                    cancel={{back: true}}
                    extra={{
                        className: 'btn-danger',
                        label: 'Delete',
                        onClick: () => confirm(
                            {
                                theme: 'danger',
                                title: 'Delete service',
                                message: `Are you sure you want to delete the service "${service.title}"?`
                            },
                            () => deleteService().then(() => window.history.back())
                        )
                    }}
                />
            </Form>
        </Page>
    </>
}

export default Edit;
